export const errorHandledError = new Error('Error Handled');
